import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 300 }
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  search(event) {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      event.target.form.requestSubmit()
    }, this.delayValue)
  }
}
